import { NomineeType } from "../types";

const badges: Record<NomineeType, { src: string; alt: string }> = {
  citadine: {
    src: "/images/trophy-banner/citadine.svg",
    alt: "Meilleure citadine électrique 2026",
  },
  familiale: {
    src: "/images/trophy-banner/familiale.svg",
    alt: "Meilleure familiale électrique 2026",
  },
};

const TrophyBanner = ({ type }: { type: NomineeType }) => {
  const badge = badges[type];

  return (
    <header
      className="flex flex-wrap items-center justify-center gap-x-16 gap-y-2 px-4 py-2"
      style={{
        background:
          "radial-gradient(120% 260% at 46% 50%, #3a2aa7 0%, #090327 78%)",
      }}
    >
      <img
        src="/images/trophy-banner/laurier.svg"
        alt="Trophées des Véhicules Électriques 2026"
        className="h-16 lg:h-24 w-auto"
      />
      <img src={badge.src} alt={badge.alt} className="h-14 lg:h-20 w-auto" />
    </header>
  );
};

export default TrophyBanner;
